import { useEffect } from 'react'

export const META_PIXEL_ID = '2518019921972507'

type FbqQueue = {
  callMethod?: (...args: unknown[]) => void
  queue: unknown[][]
  push?: unknown
  loaded?: boolean
  version?: string
}

type PixelWindow = Window & {
  fbq?: ((...args: unknown[]) => void) & FbqQueue
  _fbq?: unknown
}

/**
 * Loads the Meta Pixel once and reports the initial PageView.
 */
export function useMetaPixel(pixelId: string = META_PIXEL_ID): void {
  useEffect(() => {
    const w = window as PixelWindow
    if (w.fbq) {
      w.fbq('track', 'PageView')
      return
    }

    const fbq = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue.push(args)
      }
    } as ((...args: unknown[]) => void) & FbqQueue

    fbq.queue = []
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    w.fbq = fbq
    w._fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)

    fbq('init', pixelId)
    fbq('track', 'PageView')
  }, [pixelId])
}

/**
 * Fires the standard InitiateCheckout event when a visitor heads to the checkout.
 */
export function trackInitiateCheckout(value: number, currency = 'USD'): void {
  const w = window as PixelWindow
  w.fbq?.('track', 'InitiateCheckout', { value, currency })
}
